import { Grid, GridItem, Button } from '@chakra-ui/react';

type BuilderTabsProps<T extends string> = {
  tabs: readonly T[];
  size: string;
  selectedTab: T;
  setSelectedTab: React.Dispatch<React.SetStateAction<T>>;
  labelMap?: Partial<Record<T, string>>;
};

const BuilderTabs = <T extends string>({
  tabs,
  size,
  selectedTab,
  setSelectedTab,
  labelMap,
}: BuilderTabsProps<T>) => {
  return (
    <Grid templateColumns={`repeat(${tabs.length}, 1fr)`} gap={2} mb={6} w="full" h="full">
      {tabs.map((tab) => (
        <GridItem key={tab}>
          <Button
            w="full"
            h="full"
            size={size}
            variant={selectedTab === tab ? 'gradient' : 'grey'}
            onClick={() => setSelectedTab(tab)}
          >
            {labelMap?.[tab] ?? tab}
          </Button>
        </GridItem>
      ))}
    </Grid>
  );
};

export default BuilderTabs;
